
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.128 3c7.25 0 13.127 5.877 13.127 13.128 0 3.07-1.054 5.895-2.82 8.131l6.097 6.1a1.5 1.5 0 01-1.98 2.246l-.141-.125-6.094-6.092a13.073 13.073 0 01-8.19 2.867C8.878 29.255 3 23.378 3 16.128 3 8.878 8.877 3 16.128 3zm0 3C10.534 6 6 10.534 6 16.128c0 5.593 4.534 10.127 10.128 10.127 5.593 0 10.127-4.534 10.127-10.127C26.255 10.534 21.721 6 16.128 6z","fill":"currentColor"}})])
          )
        }
      }
    